import changeDeckStatus from '../../assets/setup/tutorial_change_deck_status.png';

export const HideDecks: React.FC = () => {
    return (
        <div className="flex flex-col justify-center gap-y-4">
            <p>Hide your decks within Deck Hopper. Hidden decks are still active.</p>
            {/* Mobile Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Mobile</h2>
                <ul className="list-disc list-inside">
                    <li>Long tap on a deck thumbnail while in a deck list to hide or show it.
                        <img className="mt-2 mb-3" src={changeDeckStatus} alt="Change deck status" width="300" />

                    </li>
                </ul>
            </div>

            {/* Desktop Instructions */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Desktop</h2>
                <ul className="list-disc list-inside">
                    <li>Right click on a deck thumbnail while in a deck list to hide or show it.</li>
                </ul>
            </div>

            {/* Shared Information */}
            <div className="flex flex-col gap-y-2">
                <h2 className="text-lg font-bold">Additional Information</h2>
                <ul className="list-disc list-inside">
                    <li>Unlike disabled decks, hidden decks are still active.</li>
                    <li>You can still interact with hidden decks and use Deck App: Switch Deck commands.</li>
                    <li>Hidden decks will be skipped when cycling through them.</li>
                    <li>You can toggle the visibility of hidden decks by going to Menu - Settings - Deck Management - Show Hidden Decks.</li>
                </ul>
            </div>
        </div>
    );
};
